"use strict";
/**
 * This file is auto-generated. Do not modify directly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = exports.LocaleData = exports.getLocalizeFormat = void 0;
/* istanbul ignore next */
function getLocalize() {
    var globalContainer;
    if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
        globalContainer = global;
    }
    else {
        globalContainer = window;
    }
    var localizeNamespace = globalContainer;
    if (typeof CustomLocalizeNamespace === 'string') {
        localizeNamespace = globalContainer[CustomLocalizeNamespace];
    }
    if (typeof localizeNamespace.Localize === 'undefined') {
        throw Error('The messages.<locale>.js file has not been loaded');
    }
    return localizeNamespace.Localize;
}
;
/* istanbul ignore next */
var getLocalizeFormat = function () {
    var localize = getLocalize();
    if (localize.format === undefined) {
        throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
    }
    return localize.format;
};
exports.getLocalizeFormat = getLocalizeFormat;
/* istanbul ignore next */
exports.LocaleData = { get: function () { return exports.getLocalizeFormat().localeData; } };
var t = function (k, a) { return getLocalize().msg.formatMessage(k, a); };
exports.Messages = {
    Gain: function () { return t('@tableau__prediction-model-results-viz/Gain'); },
    CumulativeCaptureRate: function () { return t('@tableau__prediction-model-results-viz/CumulativeCaptureRate'); },
    CumulativeDataFraction: function () { return t('@tableau__prediction-model-results-viz/CumulativeDataFraction'); },
    NoModel: function () { return t('@tableau__prediction-model-results-viz/NoModel'); },
    Model: function () { return t('@tableau__prediction-model-results-viz/Model'); },
    ValidationSet: function () { return t('@tableau__prediction-model-results-viz/ValidationSet'); },
    Positive: function () { return t('@tableau__prediction-model-results-viz/Positive'); },
    Negative: function () { return t('@tableau__prediction-model-results-viz/Negative'); },
    Actual: function () { return t('@tableau__prediction-model-results-viz/Actual'); },
    Predicted: function () { return t('@tableau__prediction-model-results-viz/Predicted'); },
    FalsePositive: function () { return t('@tableau__prediction-model-results-viz/FalsePositive'); },
    FalseNegative: function () { return t('@tableau__prediction-model-results-viz/FalseNegative'); },
    TruePositive: function () { return t('@tableau__prediction-model-results-viz/TruePositive'); },
    TrueNegative: function () { return t('@tableau__prediction-model-results-viz/TrueNegative'); },
    Tpr: function () { return t('@tableau__prediction-model-results-viz/Tpr'); },
    Fpr: function () { return t('@tableau__prediction-model-results-viz/Fpr'); },
    ChartScoreLabel: function (a) { return t('@tableau__prediction-model-results-viz/ChartScoreLabel', a); },
    ThresholdFootNote: function (a) { return t('@tableau__prediction-model-results-viz/ThresholdFootNote', a); },
    AlertRecommendation: function () { return t('@tableau__prediction-model-results-viz/AlertRecommendation'); },
    AlertStatus: function () { return t('@tableau__prediction-model-results-viz/AlertStatus'); },
    AlertDefinition: function () { return t('@tableau__prediction-model-results-viz/AlertDefinition'); },
    NeedsReview: function () { return t('@tableau__prediction-model-results-viz/NeedsReview'); },
    RecommendationHeader: function () { return t('@tableau__prediction-model-results-viz/RecommendationHeader'); },
    RecommendationDescription: function () { return t('@tableau__prediction-model-results-viz/RecommendationDescription'); },
    ReviewAlerts: function () { return t('@tableau__prediction-model-results-viz/ReviewAlerts'); },
    IgnoredAlerts: function () { return t('@tableau__prediction-model-results-viz/IgnoredAlerts'); },
    AcceptedAlerts: function () { return t('@tableau__prediction-model-results-viz/AcceptedAlerts'); },
    QualityCheck: function () { return t('@tableau__prediction-model-results-viz/QualityCheck'); },
    QualityCheckPass: function () { return t('@tableau__prediction-model-results-viz/QualityCheckPass'); },
    QualityCheckFail: function () { return t('@tableau__prediction-model-results-viz/QualityCheckFail'); },
    DataLeakageMessageSingular: function (a) { return t('@tableau__prediction-model-results-viz/DataLeakageMessageSingular', a); },
    DataLeakageMessageSingularSecond: function (a) { return t('@tableau__prediction-model-results-viz/DataLeakageMessageSingularSecond', a); },
    DataLeakageMessagePlural: function (a) { return t('@tableau__prediction-model-results-viz/DataLeakageMessagePlural', a); },
    DataLeakageMessagePluralSecond: function (a) { return t('@tableau__prediction-model-results-viz/DataLeakageMessagePluralSecond', a); },
    DataLeakageFollowUp: function (a) { return t('@tableau__prediction-model-results-viz/DataLeakageFollowUp', a); },
    BiasReference: function () { return t('@tableau__prediction-model-results-viz/BiasReference'); },
    BiasImpacted: function () { return t('@tableau__prediction-model-results-viz/BiasImpacted'); },
    BiasOther: function (a) { return t('@tableau__prediction-model-results-viz/BiasOther', a); },
    BiasAdverseRatio: function () { return t('@tableau__prediction-model-results-viz/BiasAdverseRatio'); },
    NoAlertsAvailable: function () { return t('@tableau__prediction-model-results-viz/NoAlertsAvailable'); },
};
//# sourceMappingURL=Localize.js.map